import { TAG } from "../constants";
import {
  CreatePatientSubscriptionArgs,
  PatientSubscription,
  PatientSubscriptionWithOrder,
  UpdatePatientSubscription,
} from "../types";
import { patientApi } from "./patientApi";

export const patientSubscriptionApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Subscriptions
     * */
    getSubscriptions: builder.query<PatientSubscription[], void>({
      query: () => ({
        url: `/api/patient/subscriptions`,
        method: "GET",
      }),
      providesTags: [TAG.SUBSCRIPTIONS],
    }),

    createSubscription: builder.mutation<void, CreatePatientSubscriptionArgs>({
      query: (body) => ({
        url: `/api/patient/subscriptions`,
        method: "POST",
        body,
      }),
      invalidatesTags: [TAG.SUBSCRIPTIONS, TAG.NAVIGATION],
    }),
    getSubscriptionByProduct: builder.query<PatientSubscription, number>({
      query: (productId) => ({
        method: "GET",
        url: `/api/patient/subscriptions/product/${productId}`,
      }),
      providesTags: [TAG.SUBSCRIPTIONS],
    }),
    getSubscriptionById: builder.query<PatientSubscriptionWithOrder, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/patient/subscriptions/${id}`,
      }),
      providesTags: [TAG.SUBSCRIPTIONS],
    }),
    updateSubscription: builder.mutation<
      PatientSubscription,
      UpdatePatientSubscription
    >({
      query: (body) => ({
        method: "PUT",
        url: `/api/patient/subscriptions/${body.id}`,
        body,
      }),
    }),
    reactivateSubscription: builder.mutation<
      PatientSubscription | { refill_url: string },
      number
    >({
      query: (id) => ({
        method: "POST",
        url: `/api/patient/subscriptions/reactivate/${id}`,
      }),
      invalidatesTags: [TAG.SUBSCRIPTIONS, TAG.TASKS],
    }),
    getCanceledSubscriptionByProduct: builder.query<
      PatientSubscription,
      number
    >({
      query: (productId) => ({
        method: "GET",
        url: `/api/patient/subscriptions/canceled/${productId}`,
      }),
      providesTags: [TAG.SUBSCRIPTIONS],
    }),
    getCanceledSubscriptions: builder.query<PatientSubscription[], void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/subscriptions/canceled`,
      }),
      providesTags: [TAG.SUBSCRIPTIONS],
    }),
  }),
});

export const {
  useGetSubscriptionByProductQuery,
  useGetSubscriptionsQuery,
  useCreateSubscriptionMutation,
  useGetSubscriptionByIdQuery,
  useUpdateSubscriptionMutation,
  useReactivateSubscriptionMutation,
  useGetCanceledSubscriptionByProductQuery,
  useGetCanceledSubscriptionsQuery,
} = patientSubscriptionApi;
